import { authRef, databaseRef } from 'config'
import { action } from '../../dispatchAction'
import { getColIdFromEmail } from '../getColIdFromEmail'
import { insertNewValue } from '../insertNewValue'
import { USER_ACTION_TYPES } from '../types'
import { updateForms } from '../updateForms'
import { updatePatients } from '../updatePatients'

export const signInWithEmailLink = (
  email: string,
  password: string,
  location: string,
  successCallback: () => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async dispatch => {
  if (!email) {
    errorCallback('Please provide your email for confirmation')
    return
  }

  if (authRef.isSignInWithEmailLink(location)) {
    authRef
      .signInWithEmailLink(email, location)
      .then(response => {
        const user = authRef.currentUser
        if (user) {
          user
            .updatePassword(password)
            .then(() => {
              const emailKey = getColIdFromEmail(email)

              databaseRef
                .child(`users_tmp/${emailKey}`)
                .once('value')
                .then(async usersTableData => {
                  try {
                    await insertNewValue(email, null, 'users_tmp', true)

                    const role = usersTableData.val().role
                    const userId = response.user!.uid

                    await insertNewValue(userId, usersTableData.val(), 'users')

                    await updateForms(emailKey, userId)

                    await updatePatients(role, email, emailKey, userId)
                      .then(() => successCallback())
                      .catch(message => errorCallback(message))
                  } catch (error) {
                    const { message } = error
                    errorCallback(message)
                  }
                })
                .catch(error => {
                  const { code, message } = error
                  dispatch(
                    action(USER_ACTION_TYPES.login_error, {
                      code,
                      message
                    })
                  )

                  errorCallback(message)
                })
            })
            .catch(() => {
              errorCallback('Password is not setted')
            })
        } else {
          errorCallback('No current user')
        }
      })
      .catch(error => {
        const { message } = error

        errorCallback(message)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions/signInWithEmailLink.action.ts